import _ from "lodash";

function kebabCaseToTitleCase(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }

    // The regular expression /-/g ensures ALL hyphens are replaced.
    const spacedStr = str.replace(/-/g, ' ');
    const titleCaseStr = spacedStr
        .split(' ')
        .map(word => {
            if (word.length === 0) {
                return '';
            }
            // Capitalize the first letter, and append the rest of the word in lowercase.
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');

    return titleCaseStr;
}

const buildParagraphLines = (container, questions) => {
    container.style.padding = '20px';
    container.style.fontFamily = 'Arial, sans-serif';
    let email;
    for (const [question, obj] of Object.entries(questions)) {
        
        if (question === "token-authentication"){
            continue;
        }
        
        if (question === "personal-information"){
            let field = obj["Contact Details"];
            email = field["Email Address"]['text'];
        }

        // --- section ---
        let section = document.createElement("p");
        section.textContent = `${kebabCaseToTitleCase(question)}`;
        
        section.style.fontWeight = 'bold';
        section.style.fontSize = '1.1em';
        section.style.color = '#333';
        section.style.marginBottom = '5px';
        section.style.marginTop = '15px';

        container.appendChild(section);

        // --- questions - asnwer ---
        if (_.isPlainObject(obj)) {
            for (const [field, answer] of Object.entries(obj)) {
                let question_div = document.createElement("p");

                question_div.style.fontWeight = 'bold';
                question_div.style.fontSize = '1em';
                question_div.style.color = '#555';
                question_div.style.marginLeft = '20px';
                question_div.style.lineHeight = '1.4';
                question_div.style.marginBottom = '3px';
                
                question_div.textContent = `${field}:`;
                container.appendChild(question_div);
                for (const [f, a] of Object.entries(answer)){
                    let ans = document.createElement("p");
                    ans.style.fontSize = '1em';
                    ans.style.color = '#555';
                    ans.style.marginLeft = '20px';
                    ans.style.lineHeight = '1.4';
                    ans.style.marginBottom = '3px';
                    ans.textContent = '';
                    if (f === "radio-selection") {
                        // ans.textContent = `${field}:`;
                        ans.textContent += `Selected: ${a['radio']}\n`;
                        // Special styling for radio answer
                        ans.style.fontStyle = 'italic'; 
                    }
                    else if (f === "text-area") {
                        ans.textContent += `${a['text']}`;
                    } 
                    else if (f === "checkbox-selection") {
                        // ans.textContent = `${field}:`;
                        if (a['checkbox'] === true){
                            ans.textContent += `Status: Confirmed\n`;
                        }
                    } 
                    else {
                        ans.textContent += `${f}: ${a['text']}`;
                    }
                    container.appendChild(ans);
                    // Add a bottom margin to separate the field groups
                    if (Object.keys(obj).indexOf(f) === Object.keys(obj).length - 1) {
                        ans.style.marginBottom = '20px';
                    }
                }
            }
        }
    }
    return {
        container: container,
        email: email,
    };
};

const createReportTitle = (titleText) => {
    const title = document.createElement("h1");
    title.textContent = titleText;
    title.style.textAlign = 'center';
    title.style.color = '#1E3A8A'; // Dark blue
    title.style.borderBottom = '3px solid #E5E7EB';
    title.style.paddingBottom = '10px';
    title.style.marginBottom = '30px';
    return title;
};

const createReportFooter = (date) => {
    const footer = document.createElement("footer");
    footer.style.textAlign = 'center';
    footer.style.marginTop = '40px';
    footer.style.paddingTop = '10px';
    footer.style.borderTop = '1px dashed #DDD';
    footer.style.fontSize = '0.9em';
    footer.style.color = '#999';
    
    // Example text content for the footer
    footer.innerHTML = `Report Generated: ${date} <br/> 
                        Confidential | Surgical Assessment Use Only`;
    return footer;
};

const generateReport = (reportData, reportTitle) => {
    const reportContainer = document.createElement('div');
    reportContainer.id = 'form-report-output';
    reportContainer.style.maxWidth = '800px';
    reportContainer.style.margin = '0 auto';
    reportContainer.style.padding = '20px';

    const title = createReportTitle(reportTitle);
    reportContainer.appendChild(title);
    const { container, email } = buildParagraphLines(reportContainer, reportData);
    const currentDate = new Date().toLocaleDateString();
    const footer = createReportFooter(currentDate);
    container.appendChild(footer);

    // return [reportContainer, email];
    return {
        reportContainer: container,
        email: email,
    };
};

export default generateReport;